<app-social-content-tiles-list
  class="w-fill-available"
  [analyticsNodes]="analyticsNodes()"
  [loading]="loading()"
  [noCampaignContextMode]="true"
  (tileClicked)="onTileClick($event)"
/>
